import $http from '@/plugins/axios'
import VueCookies from 'vue-cookies'
import $const from '@/utils/const'
import store from '@/store/store'

const ProjectService = {
    getLocalActiveProjectId () {
        let email = store.state.auth.profile.email
        if (email) {
            let projectId = VueCookies.get(`${email}_${$const.currentProjectIdKey}`)
            return projectId || ''
        }
        return ''
    },
    setLocalActiveProjectId (projectId) {
        let email = store.state.auth.profile.email
        return VueCookies.set(`${email}_${$const.currentProjectIdKey}`, projectId)
    },
    getProjects () {
        return $http.get('/rate-campaign/')
    },
    createProject (name, description, botCode) {
        return $http.post('/rate-campaign/', { name, description, bot_code: botCode })
    },
    deleteProject (projectId) {
        return $http.delete(`/rate-campaign/${projectId}/`)
    }
}
export default ProjectService
